/**
 * Types Redux du domaine Invoice + FinancialTransaction.
 */

/* ------------------------------------------------------------------ */
/* Invoice                                                             */
/* ------------------------------------------------------------------ */

export const CREATE_INVOICE_REQUEST = "CREATE_INVOICE_REQUEST";
export const CREATE_INVOICE_SUCCESS = "CREATE_INVOICE_SUCCESS";
export const CREATE_INVOICE_FAILURE = "CREATE_INVOICE_FAILURE";

export const DELETE_INVOICE_REQUEST = "DELETE_INVOICE_REQUEST";
export const DELETE_INVOICE_SUCCESS = "DELETE_INVOICE_SUCCESS";
export const DELETE_INVOICE_FAILURE = "DELETE_INVOICE_FAILURE";

export const GET_INVOICE_BY_ID_REQUEST = "GET_INVOICE_BY_ID_REQUEST";
export const GET_INVOICE_BY_ID_SUCCESS = "GET_INVOICE_BY_ID_SUCCESS";
export const GET_INVOICE_BY_ID_FAILURE = "GET_INVOICE_BY_ID_FAILURE";

export const GET_INVOICES_BY_PATIENT_REQUEST = "GET_INVOICES_BY_PATIENT_REQUEST";
export const GET_INVOICES_BY_PATIENT_SUCCESS = "GET_INVOICES_BY_PATIENT_SUCCESS";
export const GET_INVOICES_BY_PATIENT_FAILURE = "GET_INVOICES_BY_PATIENT_FAILURE";

export const INITIATE_PAYMENT_REQUEST = "INITIATE_PAYMENT_REQUEST";
export const INITIATE_PAYMENT_SUCCESS = "INITIATE_PAYMENT_SUCCESS";
export const INITIATE_PAYMENT_FAILURE = "INITIATE_PAYMENT_FAILURE";

export const MARK_INVOICE_AS_PAID_CASH_REQUEST = "MARK_INVOICE_AS_PAID_CASH_REQUEST";
export const MARK_INVOICE_AS_PAID_CASH_SUCCESS = "MARK_INVOICE_AS_PAID_CASH_SUCCESS";
export const MARK_INVOICE_AS_PAID_CASH_FAILURE = "MARK_INVOICE_AS_PAID_CASH_FAILURE";

/* ------------------------------------------------------------------ */
/* FinancialTransaction                                                */
/* ------------------------------------------------------------------ */

export const GET_FINANCIAL_TRANSACTIONS_REQUEST = "GET_FINANCIAL_TRANSACTIONS_REQUEST";
export const GET_FINANCIAL_TRANSACTIONS_SUCCESS = "GET_FINANCIAL_TRANSACTIONS_SUCCESS";
export const GET_FINANCIAL_TRANSACTIONS_FAILURE = "GET_FINANCIAL_TRANSACTIONS_FAILURE";

export const ASSIGN_TRANSACTION_TO_INVOICE_REQUEST = "ASSIGN_TRANSACTION_TO_INVOICE_REQUEST";
export const ASSIGN_TRANSACTION_TO_INVOICE_SUCCESS = "ASSIGN_TRANSACTION_TO_INVOICE_SUCCESS";
export const ASSIGN_TRANSACTION_TO_INVOICE_FAILURE = "ASSIGN_TRANSACTION_TO_INVOICE_FAILURE";
